import { cleanFilters } from 'utils/filters'
import { useIntl } from 'react-intl'
import { SRP_TYPE } from 'enums'
import auctionApi from 'utils/api/auctionApi'

const URLS = {
  SRP: '/auctions/vehicles',
  WINNER: '/dealers/auctions/winner',
  STATUS: '/dealers/auctions/bids',
  OPEN: '/auctions/vehicles?status=open',
}

export const getAuctionVehicles = async (filters, perPage, section = 'SRP', token = '') => {
  const headers = {
    Authorization: `Bearer ${token}`,
  }
  const url = URLS[section]
  const params = cleanFilters(filters)
  const { data } = await auctionApi(
    url,
    {
      params: { perPage, ...params },
      timeout: 15000,
      headers,
    },
  ).catch((err) => {
    // eslint-disable-next-line no-console
    console.log('err', err) // TODO check this
  })
  return data
}

export const getSRPath = (srpType = SRP_TYPE.NORMAL, isDraftEasy = false) => {
  const { formatMessage: f } = useIntl()
  let srpBasePath
  const basePath = f({ id: 'ROUTE_SEARCH' })
  const srpFiltersBasePath = f({ id: 'ROUTE_SEARCH_FILTERS' })
  const isDraftEasyPath = f({ id: 'ROUTE_SEARCH_DRAFT_EASY' })
  const isEasyVirtualParticularPath = f({ id: 'ROUTE_SEARCH_VIRTUAL_PARTICULAR' })
  if (isDraftEasy) {
    srpBasePath = isDraftEasyPath
  } else if (srpType === SRP_TYPE.FILTERS) {
    srpBasePath = srpFiltersBasePath
  } else if (srpType === SRP_TYPE.VIRTUALS) {
    srpBasePath = isEasyVirtualParticularPath
  } else {
    srpBasePath = basePath
  }
  return srpBasePath
}
